export const playData = {
    handlePlay: null
};
